import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=31d4f608&scoped=true&lang=pug&"
import script from "./NewCompany.vue?vue&type=script&lang=js&"
export * from "./NewCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4f608",
  null
  
)

export default component.exports